import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { CardHeaderSkeleton, ChartSkeleton } from '@/components/ui/skeletons';
import { ReactNode } from 'react';
import classnames from 'classnames';

interface MetricsChartCardProps {
  title: string;
  description?: string;
  isLoading?: boolean;
  tooltip?: ReactNode;
  children: ReactNode;
  noBorder?: boolean;
}

export function MetricsChartCard({
  title,
  description,
  isLoading = false,
  tooltip,
  children,
  noBorder = false
}: MetricsChartCardProps) {
  const borderClass = classnames('border', 'rounded-lg', {
    '!border-0': noBorder
  });

  return (
    <Card className={borderClass}>
      <CardHeader className="p-4">
        {isLoading ? (
          <CardHeaderSkeleton />
        ) : (
          <>
            <div className="flex items-center gap-1">
              <CardTitle className="text-lg font-semibold text-card-foreground">{title}</CardTitle>
              {tooltip && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Info className="h-3.5 w-3.5 text-muted-foreground cursor-pointer" />
                    </TooltipTrigger>
                    <TooltipContent>{tooltip}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
            {description && <CardDescription>{description}</CardDescription>}
          </>
        )}
      </CardHeader>
      <CardContent>{isLoading ? <ChartSkeleton /> : children}</CardContent>
    </Card>
  );
}
